'use client';

import * as React from 'react';

import { useParams } from 'react-router-dom';

import { STORE_ROUTES } from '@/config/router';
import { ResourceBadge } from '@/components/ui/resource-badge';

interface PromotionResourceBadgeProps {
    promotionId: string;
    storeId?: string;
    variant?: 'default' | 'secondary' | 'destructive' | 'outline';
    className?: string;
}

/**
 * PaymentResourceBadge component for displaying payment information
 * Inherits from generic ResourceBadge
 */
export function PromotionResourceBadge({
    promotionId,
    storeId,
    variant = 'secondary',
    className,
}: PromotionResourceBadgeProps) {
    const { orgSlug, id: paramStoreId } = useParams();
    const resolvedStoreId = storeId ?? paramStoreId;
    if (!orgSlug) {
        throw new Error('Org slug is required');
    }
    if (!resolvedStoreId) {
        throw new Error('Store ID is required');
    }
    const routes = STORE_ROUTES(orgSlug, resolvedStoreId);
    // Format display value based on available data
    const displayValue = React.useMemo(() => {
        return `${promotionId.substring(0, 8)}...`;
    }, [promotionId]);

    return (
        <ResourceBadge
            name="variant"
            value={displayValue}
            appLink={routes.DISCOUNT_DETAILS(promotionId)}
            variant={variant}
            className={className}
        />
    );
}
